import React, { useState } from 'react'
import Select from "react-select"
import Creatable from "react-select/creatable"
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Dropdown, Select as AntSelect, Menu, DatePicker } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../components/resusable/receive'

import { useToggle, useListData, usePet, stringifyDate } from '../modules'
import NewInvoice from '../components/modals/newInvoice'
import Invoice from '../components/modals/invoice'

const { RangePicker } = DatePicker

const Invoices = () => {
    const [ranges, setRanges] = useState()
    const [suppliers, setSuppliers] = useState(['All Suppliers'])
    const [supplier, setSupplier] = useState({ label: 'All Suppliers', value: 'All' })
    const [selected, setSelected] = useState(null)
    const [string, setString] = useState('')

    // const { option, setOption, dropdown } = useDropDown(['Select', 'Delete', 'Renew'])

    const [invoiceModal, toggleInvoiceModal] = useToggle()
    const [newInvoiceModal, toggleNewInvoiceModal] = useToggle()

    const select = inv => {
        setSelected(inv)
        toggleInvoiceModal()
    }

    const [
        { loading: invLoading, error: invError, fetch },
        { list: invoices },
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('invoices', ranges ?
        { string, direction: 'in', supplier: supplier?.value, from: ranges[0]?._d ?? null, to: ranges[1]?._d ?? null }
        : { string, direction: 'in', supplier: supplier?.value }
        , { notify: true, manual: false })

    const [{ loading: supLoading, error: supError }, getSuppliers] = usePet('suppliers', {}, { notify: true, callback: ({ data }) => setSuppliers(['All Suppliers', ...data]), logOutOnError: true })

    const [{ loading: dLoading }, deleteInvoice] = usePet('deleteInvoice', {
        id: selected?._id
    }, { notify: true, callback: (_, notif, ops) => {
        notif('Invoice has been deleted', ops('success'))
        setTimeout(() => {
            fetch()
            getSuppliers()
        }, 300)
    }, manual: true, load: { msg: 'Deleting...' } })

    const deletInv = inv => {
        setSelected(inv)
        deleteInvoice()
    }

    const selectRange = range => {
        setRanges(range)
        navigate(1)
        fetch()
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0) {
            fetch()
            navigate(1)
        }
    }

    const refetch = () => {
        fetch()
        getSuppliers()
    }

    const selectSupplier = val => {
        setSupplier(val)
        navigate(1)
        fetch()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {
                invoiceModal &&
                <Invoice
                    onPerform={ refetch }
                    invoice={selected}
                    toggle={toggleInvoiceModal}
                    visible={invoiceModal} />
            }
            <Receive
                error={supError}
                loading={supLoading}
                progress>
                <NewInvoice
                    onPerform={ refetch }
                    suppliers={suppliers}
                    toggle={toggleNewInvoiceModal}
                    visible={newInvoiceModal} />
            </Receive>
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" /> */}
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Invoice Using Code" />
                <div className="grid grid-flow-col sm:auto-cols-max items-center justify-center sm:justify-end gap-2">
                    <RangePicker onChange={selectRange} />
                    {/* <Select
                        value={ store }
                        onChange={ selectStore }
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={ stores }
                        placeholder="Select Store" /> */}
                    <button onClick={toggleNewInvoiceModal} className="btn hisani-btn-green text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">Receive Invoice</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Invoices</h2>
                    <Select
                        value={supplier}
                        onChange={selectSupplier}
                        styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                        options={suppliers.map(sup => ({ label: sup, value: sup === 'All Suppliers' ? 'All' : sup }))}
                        placeholder="Select Supplier" />
                </header>
                <div className="p-3">

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <Receive
                            error={invError}
                            loading={invLoading}
                            progress>
                            {
                                invoices.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Code</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Supplier</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Status</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Date</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                invoices.map((invoice, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{invoice?.code}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{invoice?.supplier}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{invoice?.committed ? 'Committed' : 'Commit Pending'}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{stringifyDate(invoice.date)}</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => select(invoice) }>View</Menu.Item>
                                                                        {
                                                                            !invoice?.committed &&
                                                                            <Menu.Item onClick={() => deletInv(invoice)}>Delete</Menu.Item>
                                                                        }
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    :
                                    <div className="w-full h-16 flex items-center justify-center">
                                        <p className="font-semibold text-base">Please click above to add a new invoice</p>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Invoices